import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const listRuleOutputs = createAsyncThunk("ruleConfiguration/listRuleOutputs", async (payload) => {
  try {
    const response = await magnifiAPI.listRuleOutputs(payload);

    return response?.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
